// Resources
import { Person } from "fhir/r5";
// FHIR
import { loadAllResources, loadResource } from "./FhirBundleService";

const PERSON_SEARCH_PARAMS = {
  _count: "200",
  _elements: "id,name,identifier,active,gender,birthDate,link",
  _sort: "name",
};

/**
 * Load the Person resource from the back to populate the fields.
 *
 * @returns the promise of a Person.
 */
async function loadPerson(userId: string): Promise<Person> {
  return loadResource<Person>("Person", userId ?? "");
}

async function loadAllPersons(): Promise<Person[]> {
  return loadAllResources<Person>("Person", PERSON_SEARCH_PARAMS);
}

///////////////////////////////
//         Exports           //
///////////////////////////////

const PersonService = {
  loadPerson,
  loadAllPersons,
};

export default PersonService;
